<template>
  
  <div class="order-list tt-custom-tab article font16" :style="{'height':tableHeight+'px'}">
    <div v-if="step==0" style="padding: 24px 24px 0;height: 100%;overflow: auto;">
      <el-tabs v-model="mediaType" class="articletab" @tab-click="handleClick">
        <el-tab-pane label="上传图片" name="picture">
          <div style="padding-top:13px;position:relative;">
            <p class="savewarning" v-if="saveContent"><i class="el-icon-warning" style="margin:0 7px 0 17px"></i>
              已为你保存最近一条编辑且未发布的图文笔记，重新上传将会自动放弃本次内容
              <span style="color:#0F66CF;margin:0 15px;cursor: pointer;" @click="editSave">继续编辑</span>
              <span style="color:rgba(0,0,0,0.53);cursor: pointer;" @click="clearSave(true)">放弃</span>
            </p>
            <el-upload class="article-upload" :class="{'haswarning':saveContent}"
                :drag="true"
                action="#"
                :headers="uploadheaders"
                :on-change="handleFileChange"
                :before-upload="beforeUpload"
                :multiple="true"
                :limit="restLimit"
                name="pictures[]">
                <div class="drag-upload">
                  <div>
                    <img src="../../ico/upload@2x.png" style="width:60px;height:56px;margin-bottom:7px;"/>
                  </div>
                  <div style="font-size: 16px;color: #666;margin-bottom: 20px;">
                    上传图片
                  </div>
                  <p style="font-size: 10px;color: #999;">
                    拖拽图片到此或点此上传(最多支持上传18张)
                  </p>
                  <!--<el-button class="btn-14" type="info" style="width:104px;height:38px;margin-top:20px;">
                    上传图片
                  </el-button>-->
                </div>
              </el-upload>
            <div style="display:flex;padding:50px 0;">
              <div class="tip">
                <div style="text-align: left;display: inline-block;">
                  <p style="font-size: 14px;margin-bottom: 4px;line-height: 20px;">图片大小</p>
                  <p style="font-size: 12px;color:rgba(0, 0, 0, 0.53);line-height: 20px;">支持上传的图片大小，<br />最大32MB的图片文件</p>
                </div>
              </div>
              <div class="tip">
                <div style="text-align: left;display: inline-block;">
                  <p style="font-size: 14px;line-height: 22px;margin-bottom: 4px;line-height: 20px;">图片格式</p>
                  <p style="font-size: 12px;color:rgba(0, 0, 0, 0.53);line-height: 20px;">支持上传的图片格式，<br />推荐使用png、jpg、jpeg、webp，不支持gif、live及其转化后的图片</p>
                </div>
              </div>
              <div class="tip">
                <div style="text-align: left;display: inline-block;">
                  <p style="font-size: 14px;line-height: 22px;margin-bottom: 4px;line-height: 20px;">图片分辨率</p>
                  <p style="font-size: 12px;color:rgba(0, 0, 0, 0.53);line-height: 20px;">不限制宽高比例，推荐上传3:4至2:1之间、分辨率不低于720*960的照片，<br />超过1280P的图片用网页端上传画质更清晰</p>
                </div>
              </div>
            </div>
            <div v-if="loadingEdit" style="width:100%;height:100%;position:absolute;left:0;top:0;display: flex;align-items: center;justify-content: center;background: rgba(255,255,255,0.7)">
                <i class="el-icon-loading" style="font-size: 30px;color:#666;"></i>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="上传视频" name="video">
          <div style="padding-top:13px;">
            <p class="savewarning" v-if="videosaveContent"><i class="el-icon-warning" style="margin:0 7px 0 17px"></i>
              已为你保存最近一条编辑且未发布的视频笔记，重新上传将会自动放弃本次内容
              <span style="color:#0F66CF;margin:0 15px;cursor: pointer;" @click="editSave">继续编辑</span>
              <span style="color:rgba(0,0,0,0.53);cursor: pointer;" @click="clearSave">放弃</span>
            </p>
            <video ref="videoPlayer" style="display: none;"></video>
            <el-upload class="article-upload" :class="{'haswarning':videosaveContent}"
                :drag="true"
                :action="API_HOST + '/api/upload.php?api=good_picture&type=file'"
                :on-success="handleVideoUploadSuccess"
                :before-upload="beforeVideoReplaceUpload"
                :headers="headers"
                name="good_picture">
                <div class="drag-upload">
                  <div>
                    <img src="../../ico/upload@2x.png" style="width:60px;height:56px;margin-bottom:7px;"/>
                  </div>
                  <div style="font-size: 16px;color: #666;margin-bottom: 20px;">
                    上传视频
                  </div>
                  <p style="font-size: 10px;color: #999;">
                    拖拽视频到此或点此上传
                  </p>
                  <div v-if="uploadingVideo" style="width:100%;height:100%;position:absolute;left:0;top:0;display: flex;align-items: center;justify-content: center;background: rgba(255,255,255,0.7)">
                    <i class="el-icon-loading" style="font-size: 30px;color:#666;"></i>
                  </div>
                </div>
              </el-upload>
            <div style="display:flex;padding:50px 0;">
              <div class="tip">
                <div style="text-align: left;display: inline-block;">
                  <p style="font-size: 14px;margin-bottom: 4px;line-height: 20px;">视频大小</p>
                  <p style="font-size: 12px;color:rgba(0, 0, 0, 0.53);line-height: 20px;">支持时长60分钟以内，<br />最大20GB的视频文件</p>
                </div>
              </div>
              <div class="tip">
                <div style="text-align: left;display: inline-block;">
                  <p style="font-size: 14px;line-height: 22px;margin-bottom: 4px;line-height: 20px;">图片格式</p>
                  <p style="font-size: 12px;color:rgba(0, 0, 0, 0.53);line-height: 20px;">支持常用视频格式，<br />推荐使用mp4、mov</p>
                </div>
              </div>
              <div class="tip">
                <div style="text-align: left;display: inline-block;">
                  <p style="font-size: 14px;line-height: 22px;margin-bottom: 4px;line-height: 20px;">视频分辨率</p>
                  <p style="font-size: 12px;color:rgba(0, 0, 0, 0.53);line-height: 20px;">推荐上传720P（1280*720）及以上视频，<br />超过1080P的视频用网页端上传画质更清晰</p>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-else style="height:100%;display: flex;flex-direction: column;">
      <div class="content-wrapper">
        <template v-if="mediaType=='video'">
          <div style="margin-bottom:24px;" @click="save">
              <i class="el-icon-arrow-left" style="font-size:20px;color:#aaa;cursor: pointer;"></i>
              <label style="font-size:20px;">发布视频</label>
            </div>
          <div class="video-info">
            <div>
              <div style="line-height: 24px;">
                {{ videoInfo.videoName }}
              </div>
              <div style="margin-top:6px;line-height: 24px;">
                <i class="el-icon-success" style="color:#1aad19;margin-right:8px;"></i>
                <label>上传成功</label>
                <label style="margin-left:24px;color:rgba(0,0,0,.53)">视频大小：{{ videoInfo.videoSize }}</label>
                <label style="margin-left:24px;color:rgba(0,0,0,.53)">视频时长：{{ videoInfo.videoduration }}</label>
              </div>
            </div>
            <div>
              <el-upload class="video-replace"
                :drag="true"
                :action="API_HOST + '/api/order_v2.php?api=upload_picture'"
                :on-success="handleVideoUploadSuccess"
                :before-upload="beforeVideoReplaceUpload"
                :headers="headers"
                name="picture">
                <div style="color:#ff4650;">
                  替换视频
                </div>
              </el-upload>
            </div>
          </div>
          <div style="font-size:18px;margin:12px 0;line-height: 26px;">
            封面设置
            <span style="font-size: 14px;color:rgba(0, 0, 0, 0.53);">默认截取第一帧作为封面，优质的封面会吸引更多人浏览笔记</span>
          </div>
          <div style="margin-top:16px;">
            <img :src="newArticle.cover_image_url" style="width:102px;height:135px;object-fit: cover;">
          </div>
        </template>
        <template v-else>
          <div style="margin-bottom:24px;" @click="save">
            <i class="el-icon-arrow-left" style="font-size:20px;color:#aaa;cursor: pointer;"></i>
            <label style="font-size:20px;">发布图文</label>
          </div>
          <div style="font-size:18px;margin:12px 0;line-height: 26px;">
            图片编辑
            <div style="float: right;color:rgba(0, 0, 0, 0.53);cursor: pointer;" @click="clearMedia">
              清空并重新上传
            </div>
          </div>
          <div style="display: flex;flex-wrap: wrap;">
            <el-upload v-show="restLimit>0"
              action="#"
              :headers="uploadheaders"
              :on-change="handleFileChange"
              :before-upload="beforeUpload"
              :multiple="true"
              :limit="restLimit"
              name="pictures[]">
              <div class="add-picture">
                <i class="el-icon-plus" style="font-size:26px;color:rgb(136,136,136);font-weight: bold;"></i>
                <label style="color:rgb(136,136,136);margin-top:10px;">添加</label>
              </div>
            </el-upload>
            <div class="add-picture-img" v-for="(img,index) in newArticle.media_list" :key="index">
              <img :src="img.url" style="width:100%;height:100%;object-fit: cover;"/>
              <div class="operations on">
                <div class="operation del" @click.stop="del(index)">
                  <i class="el-icon-close" style="color:white;"></i>
                </div>
              </div>
              <div class="operations1 on">
                <el-upload
                  :action="API_HOST + '/api/order_v2.php?api=upload_picture'"
                  :on-success="handleUploadSuccess"
                  :before-upload="beforeReplaceUpload"
                  :headers="headers"
                  name="picture">
                  <div class="operation" @click="handleReplace(index)">
                    替 换
                  </div>
                </el-upload>
              </div>
            </div>
          </div>
        </template>
        <div style="font-size:18px;margin:12px 0;line-height: 26px;">
          正文内容
          <el-dropdown v-if="post_id" style="margin-left:10px;width:122px;" @command="handleCommand">
            <el-button class="block btn-14 nohover">
              AI指令<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu class="operationStatus" slot="dropdown">
              <el-dropdown-item command="1" v-clipboard:copy="doubao_title" v-clipboard:success="onCopyTitle">复制标题指令</el-dropdown-item>
              <el-dropdown-item command="2" v-clipboard:copy="doubao_content" v-clipboard:success="onCopyContent">复制带图正文指令</el-dropdown-item>
              <el-dropdown-item command="3" v-clipboard:copy="doubao_all" v-clipboard:success="onCopyAll">复制带图全文指令</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!--<span style="margin-left:10px;color:rgba(0, 0, 0, 0.53);cursor: pointer;" @click="getDoubao">生成指令</span>-->
        </div>
        <div>
          <div>
            <el-input v-model="newArticle.title" style="width:392px;" placeholder="请输入标题"/>
          </div>
          
          <div style="margin:10px 0;">
            <!--<div id="my-toolbar">
              <button class="ql-bold" type="button">B</button>
              <button class="ql-italic">I</button>
              <button class="ql-underline">U</button>
              <button class="ql-link">链接</button>
              <button @click="uploadIMage">
                <i class="el-icon-picture-outline"></i>
              </button>
            </div>-->
            <div ref="hiddenToolbar" style="display: none">
              <button class="ql-faz-emoji"></button>
            </div>
            <quill-editor ref="myQuillEditor" @change="handlerQuill" v-model="newArticle.content" :options="editorOptions" style="height:200px;max-width:868px;"/>
          </div>
          
          <div>
            <div style="display: flex;align-items: center;">
              <span style="margin-right:12px;">关联商品</span>
              <span class="top-tag-button" @click="addRelation()" style="margin-top:0;">
                <i class="el-icon-circle-plus-outline" style="margin-right:3px;"></i>
                增加关联
              </span>
              <span v-if="newArticle.relationGoodsDisplay && newArticle.relationGoodsDisplay.length" class="top-tag-button" @click="checkStock()" style="margin-top:0;margin-left:10px;">
                检查商品库存
              </span>
            </div>
            <div style="margin:10px 0;display: flex;flex-wrap: wrap;justify-content: space-between;">
              <template v-for="(item,index) in newArticle.relationGoodsDisplay">
                <div class="relation_product_wrapper">
                    <div class="relation_product_ex">
                      <template v-if="item.type=='merchant_good'">
                        <template v-if="item.enable_alternate_images==1">
                          <div v-if="item.alternate_image_list.length" class="product_image_wrapper">
                            <img class="product_image" :src="item.alternate_image_list[0].small"/>
                          </div>
                          <div class="plh_img" style="height:48px;" v-else>
                            <div v-if="item[item.unique_param]" class="plh_img_walk" :style="{backgroundImage:'url('+item[item.unique_param].color_image_url+')'}"></div>
                          </div>
                        </template>
                        <div v-else class="product_image_wrapper">
                          <img class="product_image" :src="item.cover_image"/>
                        </div>
                        <div class="relation_product_info">
                          <p>{{ item.name }}</p>
                          <div>
                            <span class="product-price" :class="{'discounted':item.price != item.discounted_price}">{{item.price!='--'?item.currency_symbol:''}}{{item.discounted_price}}</span><del v-if="item.price != item.discounted_price" style="color:#b0b4bf">{{item.currency_symbol}}{{item.price}}</del>
                          </div>
                        </div>
                        <div class="operations on">
                          <div class="operation del" @click.stop="delRelation(index)">
                            <i class="el-icon-close" style="color:white;"></i>
                          </div>
                        </div>
                      </template>
                      <template v-if="item.type=='url'">
                        <img v-loading="item.loading" @click="editLink(item,index)" :src="item.url_image_url" style="cursor: pointer;;width:48px;height:48px;object-fit: contain;"/>
                        <div class="relation_product_info" style="cursor: pointer;" @click="editLink(item,index)">
                          <p><i class="el-icon-link" style="margin-right:3px;"></i>{{ item.url_content.name }}</p>
                          <div>
                            <span class="product-price" :class="{'discounted':item.url_content.price != item.url_content.discounted_price}">{{item.url_content.currency_symbol}}{{item.url_content.discounted_price}}</span><del v-if="item.url_content.price != item.url_content.discounted_price" style="color:#b0b4bf">{{item.url_content.currency_symbol}}{{item.url_content.price}}</del>
                            <label v-if="item.stock==0" class="editor_tag small">无货</label>
                            <label v-if="item.stock==-1" class="editor_tag small">库存未知</label>
                          </div>
                        </div>
                        <div class="operations on">
                          <div class="operation del" @click.stop="delRelation(index)">
                            <i class="el-icon-close" style="color:white;"></i>
                          </div>
                        </div>
                      </template> 
                      <div v-if="item.loading" style="position:absolute;left:0;top:0;width:100%;height:48px;background:white;opacity: 0.5;display: flex;">
                        <div v-loading="item.loading" style="margin-left:15px;">

                        </div>
                      </div>            
                    </div>
                    <div class="on" style="margin-top:10px;">
                      <el-button class="gray small" style="height:34px;" type="info" @click="setMainPic(item)">设为主图</el-button>
                    </div>
                </div>
              </template>
            </div>
          </div>
          <div style="display: flex;">
            <div style="margin-right:20px;" @click="triggerTags">
              <label class="editor_tag"># 话题</label>
            </div>
            <div style="margin-right:20px;" @click="triggerUsers">
                <label class="editor_tag">@ 用户</label>
            </div>
            <el-upload
                action="#"
                :headers="uploadheaders"
                :on-change="handleEditorFile"
                :before-upload="beforeEditorUpload"
                :multiple="true"
                name="pictures[]">
                <div style="font-size: 16px;color: #666;">
                    <label class="editor_tag">插入图片</label>
                </div>
              </el-upload>
              <div style="margin-left:20px;" @click="openInsertLink">
                <label class="editor_tag">插入链接</label>
              </div>
              <div style="margin-left:20px;" @click="openEmojiPicker">
                <label class="editor_tag">😀 表情</label>
              </div>
          </div>
          <div style="margin:20px 0;display: flex;">
            <label>活动话题</label>
            <div class="top-tag" v-for="(item,index) in topTags" :key="index">
              <p>#{{ item.tag_name }}</p>
              <p class="top-tag-button" @click="chooseTopTag(item.tag_name)">
                <i class="el-icon-circle-plus-outline" style="margin-right:3px;"></i>
                添加话题
              </p>
            </div>
          </div>
        </div>
        <div style="display:flex;align-items: center;margin-bottom: 10px;">
          <label>文章类型</label>
                <el-cascader @change="test" style="width:240px;margin-left:12px;"
          v-model="newArticle.type"
          :options="typeOptions" :show-all-levels="false" :props="{'emitPath':false}"></el-cascader>
          <!--<el-select style="width:240px;margin-left:12px;" v-model="newArticle.type">
            <el-option v-for="item in typeOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
          </el-select>-->
        </div>
        <div v-if="newArticle.type && newArticle.type!='0'" style="display:flex;align-items: center;margin-bottom: 10px;">
          <label>关联商家</label>
          <el-autocomplete class="height40_auto"
              style="width: 240px; height:40px;margin-left: 12px"
              v-model="relationMerchant"
              :fetch-suggestions="querySearch"
              @select="handleAutoSelect"
              @input="handleAutoChange"
              placeholder="商家"
            ></el-autocomplete>
        </div>
        <div style="display:flex;align-items: center;">
          <label>可见范围</label>
          <el-select style="width:240px;margin-left:12px;" v-model="newArticle.visibility">
            <el-option v-for="item in rangeOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
          </el-select>
        </div>
        <div style="display:flex;align-items: center;margin:20px 0;">
          <label>地点：</label>
          <label>{{ newArticle.location.name }}</label>
        </div>
      </div>
      <div style="padding: 12px 30px;border-top: 1px solid #d7d7d7;">
        <el-button style="width:104px;" type="info" @click="submit()" >发 表</el-button>
        <el-button class="el-button nohover" style="margin-left:20px;width:104px;" type="default" @click="save()" >暂存离开</el-button>
      </div>     
    </div>

    <div v-show="huatidialogshow" class="huatidialog" :style="{'left':huatileft,'top':huatitop}">
      <ul v-if="!searchingTag && tags.length">
        <li class="huati-item" v-for="(item,index) in tags" :key="index" @click.stop="chooseTag(item.tag_name)">
          #{{ item.tag_name }}
          <label style="float: right;color:rgba(0,0,0,0.53)">{{ item.views_count }}次浏览</label>
        </li>
      </ul>
      <div v-if="searchingTag" style="width:100%;height:100%;display: flex;" v-loading="searchingTag">
      </div>
    </div>

    <div v-show="userdialogshow" class="huatidialog" :style="{'left':huatileft,'top':huatitop}">
      <ul v-if="!searchingTag && users.length">
        <li class="huati-item" v-for="(item,index) in users" :key="index" @click.stop="chooseUser(item)">
          @{{ item.name || item.username }}
        </li>
      </ul>
      <div v-if="!searchingTag && users.length==0" style="display: flex;align-items: center;justify-content: center;height:100%;">
        没有找到相关用户
      </div>
      <div v-if="searchingTag" style="width:100%;height:100%;display: flex;" v-loading="searchingTag">
      </div>
    </div>

    <div v-show="emojiDialogshow" class="huatidialog" :style="{'left':huatileft,'top':huatitop}">
      <emoji-picker @emoji="insertEmoji" ref="emojiPicker" style="display:none;"></emoji-picker>
      <div style="padding:10px;">
            <div v-for="(emojiGroup, category) in emojis" :key="category">
              <template v-if="category!='Frequently used'">
                <h5 style="margin:8px 4px;">{{ getCategoryName(category) }}</h5>
                <div style="display: flex;justify-content: flex-start;flex-wrap: wrap;">
                  <span v-for="(emoji, emojiName) in emojiGroup"
                      :key="emojiName"
                      @click="insertEmoji(emoji)"
                      :title="chineseNames[emojiName]"
                      class="emoji-item">
                  {{ emoji }}
                  </span>
                </div>
              </template>
            </div>
        </div>
    </div>

    <el-dialog top="0" :append-to-body="true" v-if="doubaoVisible" class="el-dialog-sm custom-width-dialog-900" :close-on-click-modal="false" :visible.sync="doubaoVisible" width="600px">
      <div style="background: white;" v-loading="loadingDoubao">
        <h3 class="text-center">生成指令</h3>
        <div style="margin:10px 0;display:flex;">
          <div style="width:50px;">标题：</div>
          <p style="flex:1;white-space: pre-wrap;border: 1px dashed #ccc;border-radius: 4px;background: #f7f7f7;padding: 10px;">{{ doubao_title}}</p>
        </div>
        <div style="margin:10px 0;display:flex;">
          <div style="width:50px;">内容</div>
          <p style="height:400px;overflow: auto;flex:1;white-space: pre-wrap;;border: 1px dashed #ccc;border-radius: 4px;background: #f7f7f7;padding: 10px;">{{ doubao_content }}</p>
        </div>
        <div style="display: flex;justify-content: space-between;">
          <div class="el-button el-button--info" style="width:33%" :class="{copyTxtSuccess:copyTitleSuccess}"
              v-clipboard:copy="doubao_title"
              v-clipboard:success="onCopyTitle"
              v-clipboard:error="onError">
              {{copyTitleSuccess?'已复制标题':'复制标题'}}
          </div>
          <div class="el-button el-button--info" style="width:33%" :class="{copyTxtSuccess:copyContentSuccess}"
              v-clipboard:copy="doubao_content"
              v-clipboard:success="onCopyContent"
              >
              {{copyContentSuccess?'已复制内容':'复制内容'}}
          </div>
          <div class="el-button el-button--info" style="width:33%" :class="{copyTxtSuccess:copyAllSuccess}"
              v-clipboard:copy="doubao_all"
              v-clipboard:success="onCopyAll"
              >
              {{copyAllSuccess?'已复制全部':'复制全部'}}
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog top="0" :append-to-body="true" v-if="linkVisible" class="el-dialog-sm custom-width-dialog" :close-on-click-modal="false" :visible.sync="linkVisible" width="600px">
      <div style="background: white;">
        <h3 class="text-center">插入链接</h3>
        <div>{{ link_text }}</div>
        <div>
          <el-input style="margin:10px 0;" placeholder="链接地址" v-model="rich_text_link"></el-input>
        </div>
        <div style="display: flex;justify-content: space-between;">
          <el-button style="width:48%" class="nohover" type="default" @click="linkVisible=false">取 消</el-button>
          <el-button style="width:48%" class="nohover" type="primary" @click="insertLink">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog v-if="dialogFormVisible" top="0" class="el-dialog-sm custom-width-dialog-900" :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="90%">
      <div style="position: relative;">
        <div style="position:absolute;top:0;right:0;z-index:1">
          <el-autocomplete class="height40_auto"
              style="width: 240px; height:40px;position: relative;bottom:4px;"
              v-model="relationMerchant"
              :fetch-suggestions="querySearch"
              @select="handleAutoSelect"
              @input="handleAutoChange"
              placeholder="商家"
            ></el-autocomplete>
        </div>
        <el-tabs v-model="relationType" class="articletab" @tab-click="handleClick">
          <el-tab-pane name="normal">
            <span slot="label">系统商品</span>
            <PRODUCTLIST @select="handleSelect" :merchant_id="merchant_id" isMultiple="1" tableHeight="450px"></PRODUCTLIST>
          </el-tab-pane>
          <el-tab-pane label="收藏商品" name="collection">
            <span slot="label">收藏商品</span>
            <PRODUCTLIST @select="handleSelect" :merchant_id="merchant_id" isMultiple="1" isCollection="1" tableHeight="450px"></PRODUCTLIST>
          </el-tab-pane>
          <el-tab-pane name="link">
            <span slot="label">网页商品</span>
            <div v-show="link_step==1">
              <ul class="error-messages" v-if="errormessage">
                <li>{{errormessage}}</li>
              </ul>
              <div class="goods_info_row">
                <el-upload v-if="!currentRelationLink.url_image_url"
                  :action="API_HOST + '/api/order_v2.php?api=upload_picture'"
                  :on-success="handleRelationSuccess"
                  :before-upload="beforeRelationUpload"
                  :headers="headers"
                  name="picture">
                  <div class="add-picture" style="width:400px;height:400px;">
                    <i class="el-icon-plus" style="font-size:26px;color:rgb(136,136,136);font-weight: bold;"></i>
                    <label style="color:rgb(136,136,136);margin-top:10px;">上传图片</label>
                  </div>
                </el-upload>
                <div v-else class="realation_image_wrapper"  :style="{'width':upload_relation_image_width+'px'}">
                  <img @load="handleImageLoad($event)" :src="currentRelationLink.url_image_url" style="width:100%;height:100%"/>
                  <div class="operations on">
                    <div class="operation del" @click.stop="deleteImage">
                      <i class="el-icon-close" style="color:white;"></i>
                    </div>
                  </div> 
                </div>
                <div style="flex:1;margin-left:15px;position: relative;">
                  <el-input style="margin-bottom:10px;" placeholder="商品名称" v-model="currentRelationLink.url_content.name"></el-input>
                  <el-input style="margin-bottom:10px;" placeholder="商品网址" v-model="currentRelationLink.url"></el-input>
                  <div style="display: flex;margin-bottom:10px;justify-content: space-between;">
                    <el-input type="number" style="width:36%;" placeholder="价格" v-model="currentRelationLink.url_content.price">
                    </el-input>
                    <el-input style="margin-left:10px;width:60%" type="number" placeholder="打折价格" v-model="currentRelationLink.url_content.discounted_price">
                      <template slot="append">
                        <div style="width:92px;padding-left:11px;">
                          {{ currentRelationLink.url_content.currency }}
                        </div>
                      </template>
                    </el-input>
                  </div>
                  <div v-if="currentRelationLink.good_id">
                    <p>绑定的系统商品：</p>
                    <div class="relation_product" style="width:100%;">
                      <template v-if="currentRelationLink_bindedGood.enable_alternate_images==1">
                        <img v-if="currentRelationLink_bindedGood.alternate_image_list.length" :src="currentRelationLink_bindedGood.alternate_image_list[0].small" style="width:48px;height:48px;object-fit: contain;"/>
                        <div class="plh_img" style="height:48px;" v-else>
                          <div v-if="currentRelationLink_bindedGood[currentRelationLink_bindedGood.unique_param]" class="plh_img_walk" :style="{backgroundImage:'url('+currentRelationLink_bindedGood[currentRelationLink_bindedGood.unique_param].color_image_url+')'}"></div>
                        </div>
                      </template>
                      <img v-else :src="currentRelationLink_bindedGood.cover_image" style="width:48px;height:48px;object-fit: contain;"/>
                      <div class="relation_product_info">
                        <p><i v-if="currentRelationLink_bindedGood.good_id" class="el-icon-connection" style="margin-right:3px;"></i>{{ currentRelationLink_bindedGood.name }}</p>
                        <div>
                          <span class="product-price" :class="{'discounted':currentRelationLink_bindedGood.price != currentRelationLink_bindedGood.discounted_price}">{{currentRelationLink_bindedGood.price!='--'?currentRelationLink_bindedGood.currency_symbol:''}}{{currentRelationLink_bindedGood.discounted_price}}</span><del v-if="currentRelationLink_bindedGood.price != currentRelationLink_bindedGood.discounted_price" style="color:#b0b4bf">{{currentRelationLink_bindedGood.currency_symbol}}{{currentRelationLink_bindedGood.price}}</del>
                        </div>
                      </div>
                      <div class="operations on">
                        <div class="operation del" @click.stop="deleteBindedGoods">
                          <i class="el-icon-close" style="color:white;"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="position: absolute;bottom:0;width:100%;">
                    <el-button class="block nohover" type="default" @click="link_step=2">绑定系统商品</el-button>
                    <el-button class="block nohover" type="primary" @click="confirm()">确定关联</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="link_step==2">
                <PRODUCTLIST @select="handleLinkStepSelect" :merchant_id="merchant_id" tableHeight="450px"></PRODUCTLIST>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      
    </el-dialog>
  </div>
</template>

<script>
//import Mail from './MailBody.vue'
import api from '../../services/api.js'
import { API_HOST,CURRENCIES } from '../../services/constant.js'
import { getCategoryName,chineseNames } from '../../services/tools.js'
import PRODUCTLIST from '../../components/ProductList' 

import EmojiPicker from 'vue-emoji-picker';

//import TiptapEditor from '../../components/TiptapEditor.vue'
import draggable from 'vuedraggable'

let _ = require('lodash')

export default {
  name: 'OrderList',
  data() {
    return {
      post_monitoring_id:'',
      loadingDoubao:false,
      doubao_title:'',
      doubao_content:'',
      doubaoVisible:false,
      copyAllSuccess:false,
      copyTitleSuccess:false,
      copyContentSuccess:false,
      link_text:'',
      linkVisible:false,
      rich_text_link:'',
      atuserlist:[],
      chineseNames:chineseNames,
      getCategoryName:getCategoryName,
      emojiDialogshow:false,
      isInsertImage:false,
      merchant_country:'',
      loadingEdit:false,
      uploadingVideo:false,
      upload_relation_image_width:0,
      editIndex:-1,
      errormessage:'',
      relationType:'normal',
      currentRelationLink:{
        type:'url',
        url_content:{
          currency:'USD',
          currency_symbol:'$'
        },
        good_id:''
      },
      link_step:'1',
      dialogFormVisible:false,
      frames:[],
      CURRENCIES:CURRENCIES,
      videoInfo:{
        videoName:'',
        videoSize:'',
        videoduration:'',
      },
      restLimit:18,
      API_HOST:API_HOST,
      account_id:this.$localStorage.get('account_id'),
      newArticle:{
        type:'1',
        visibility:'0',
        location:{
          name:''
        }
      },
      typeOptions: [
        {value:'0',label:'普通'},
        {
          value:'1',
          label:'商家动态',
          children:[
          {value:'11',label:'商家上新'},{value:'12',label:'商家促销'}
          ]
        }
      ],
      rangeOptions: [{id:'0',value:'公开'},{id:'2',value:'私密'}],
      headers:{},
      uploadheaders:{},
      step:0,
      tags:[],
      users:[],
      topTags:[],
      searchingTag:false,
      huatidialogshow:false,
      userdialogshow:false,
      huatileft:'0px',
      huatitop:'0px',
      mediaType:'picture',
      isUploading:false,
      isEditorUploading:false,
      fileQueue:[],
      editorfileQueue:[],
      tableHeight:0,
      mediaIndex:-1,
      replaceing:false,
      keyword:'',
      post_id:'',
      saveContent:'',
      videosaveContent:'',
      submitting:false,
      relationMerchant:'',
      merchant_url:'',
      merchant_id:'',
      binged_goods:[],
      arr_domainInvalid:[],
      editorOptions: {
        theme: 'snow', 
        modules: {
          toolbar: false,
        },       
        placeholder: '请输入内容....'
      },
      emojis:[]
    }
  },
  components:{
    PRODUCTLIST,
    EmojiPicker,
    //TiptapEditor,
    draggable
  },
  watch:{
    'newArticle.title'(newVal, oldVal) {
      if(this.post_id)
        this.getDoubao();
    },
    'newArticle.content'(newVal, oldVal) {
      if(this.post_id)
        this.getDoubao();
    },
    step(val){
      if(val==1){
        this.$nextTick(()=>{
          
        })
      }
    }
  },
  computed:{
    doubao_all(){
      return this.doubao_title+'\n'+this.doubao_content;
    },
    currentRelationLink_bindedGood(){
      if(this.binged_goods.length)
        return this.binged_goods.find((i)=>i.id==this.currentRelationLink.good_id)
      else
        return {}
    }
  },
  created () {
    this.headers.token = this.$localStorage.get('token');
    //this.uploadheaders.token = this.$localStorage.get('token');
    this.uploadheaders={
      token:this.$localStorage.get('token'),
      'Content-Type': 'multipart/form-data'
    }
  },
  mounted() {
    this.post_id = this.$route.query.edit;
    let convert = this.$route.query.convert;
    if(convert){
      this.post_monitoring_id=convert;
      this.post_id = convert;
      this.getConvert(convert)
    }
    else if(this.post_id){
      this.getDetail(this.post_id);
    }
    else{
      if(this.$localStorage.get('article')!=null && this.$localStorage.get('article')!=''){
        this.saveContent = this.$localStorage.get('article');
        this.relationMerchant = this.$localStorage.get('article_merchant');
        this.merchant_url = this.$localStorage.get('article_merchant_url');
        this.merchant_id = this.$localStorage.get('article_merchant_id');
        if(this.$localStorage.get('article_atuser'))
          this.atuserlist = JSON.parse(this.$localStorage.get('article_atuser'))
      }
      if(this.$localStorage.get('videoarticle')!=null && this.$localStorage.get('videoarticle')!=''){
        this.videosaveContent = this.$localStorage.get('videoarticle');
        this.videoInfo = JSON.parse(this.$localStorage.get('videoInfo'));
        this.relationMerchant = this.$localStorage.get('article_merchant');
        this.merchant_url = this.$localStorage.get('article_merchant_url');
        this.merchant_id = this.$localStorage.get('article_merchant_id');
        if(this.$localStorage.get('article_atuser'))
          this.atuserlist = JSON.parse(this.$localStorage.get('article_atuser'))
      }
    }
    //console.log('article',this.newArticle)
    this.tableHeight=window.innerHeight-145;
    this.getTopTags();
    this.getLocation();
    
    //this.search()
  },
  methods: {
    handleCommand(e){
      switch(e){
        case "3":
          break;
        case "1":
          break;
      }
    },
    setMainPic(item){
      let url = '';
      if(item.type=='url'){
        url = item.url_image_url
      }
      else{
        if(item.enable_alternate_images==1){
          if(item.alternate_image_list.length)
            url = item.alternate_image_list[0].small;
        }
        else{
          url = item.cover_image;
        }
      }
      let index = this.newArticle.media_list.findIndex((i)=>i.url==url);
      if(index>-1)
        this.newArticle.media_list.splice(index,1);
      this.newArticle.media_list.unshift({type:'image',url:url})
    },
    async checkStock(){
      console.log('test',this.newArticle.relationGoodsDisplay);
      if(!this.merchant_id){
        this.$message.error('没有指定商家');
        return;
      }
      this.newArticle.relationGoodsDisplay.forEach(async (i,index)=>{
        if(i.type == 'merchant_good'){
          let id = i.id || i.good_id;
          if(id && id!='0'){
            let data = {
              for_checkout:1,
              merchant_id: this.merchant_id,
              good_id:id
            }
            i.loading = true;
            let res = await api.post(this, {
              path: 'realtime.php',
              api: 'get_product_variation',
              data: data
            })
            res = res.body
            if(res.status == 'ok' && res.result && res.result.data) {
              let default_subkeyvalue=Object.keys(res.result.data)[0];
              let t = res.result.data[default_subkeyvalue];
              i.stock = t && t[i.merchant_sku]?t[i.merchant_sku].availability:0;
            }
            else
              i.stock = 0;
            i.loading=false;
            this.$forceUpdate();
          }
        }
        else if(i.type=='url'){
            let data = {
              for_checkout:1,
              website: i.url
            }
            i.loading=true;
            let res = await api.post(this, {
              path: 'realtime.php',
              api: 'get_product_variation_by_website',
              data: data
            })
            res = res.body
            if(res.status == 'ok' && res.result && res.result.data) {
              let sku = res.result.merchant_good_sku
              let default_subkeyvalue=Object.keys(res.result.data)[0];
              let t = res.result.data[default_subkeyvalue];
              i.stock = t && t[sku]?t[sku].availability:0;
            }
            else{
              i.stock=-1
              console.log('nomatch',i)
            }
            i.loading=false;
            this.$forceUpdate();
        }
      })
    },
    onError (e) {
      console.log('error',e);
    },
    async getDoubao(){
      if(!this.newArticle.content){
        this.$message.error('帖子正文不能为空')
        return
      }
      let data = {
        source:'1',
        title:this.newArticle.title,
      }
      if(this.post_monitoring_id){
        data.post_monitoring_id=this.post_monitoring_id
      }
      else{
        data.post_id=this.post_id
      }
      let res = await api.post(this, {
        path: 'ai.php',
        api: 'convert_html_to_json',
        data: data
      })
      res = res.body
      if (res.status == 'ok') {
       this.doubao_title = res.result.title_prompt;
       this.doubao_content = res.result.content_prompt.trim();
       this.newArticle.type = res.result.text_type+'';
      } 
      //this.doubaoVisible=true;
    },
    onCopyTitle (e) {
      //console.log('copy',e);
      //this.copyTitleSuccess = true
      this.$message.success('已复制标题指令')
    },
    onCopyContent (e) {
      this.$message.success('已复制带图正文指令')
    },
    onCopyAll (e) {
      this.$message.success('已复制带图全文指令')
    },
    openEmojiPicker() {
      const quill = this.$refs.myQuillEditor.quill;
      const editorRect = quill.container.getBoundingClientRect();

      if(this.huatileft=='0px'){
        this.huatileft=Math.round(editorRect.left)+15+'px'
        this.huatitop=Math.round(editorRect.top)+15+'px'
      }
      
      const picker = this.$refs.emojiPicker
      if (picker && picker.emojis) {
        this.emojis = picker.emojis
        //console.log('emoji',this.emojis);
      }
      //const emojiModule = quill.getModule('fazEmoji')
      
      //console.log('emoji',emojiModule)
      // 确保编辑器有焦点
      quill.focus()
      this.emojiDialogshow=true;
      
      //emojiModule.openMenu()
      
    },
    insertEmoji(emoji){
        const quill = this.$refs.myQuillEditor.quill;
        quill.focus();
        const cursorPosition = quill.getSelection().index;

        this.isInsertImage=true;
        quill.insertText(cursorPosition, emoji);
        this.isInsertImage=false;
        this.emojiDialogshow=false;
        
    },
    onDragEnd(){
      this.$forceUpdate();
      //console.log('drag',this.newArticle.relationGoodsDisplay);
    },
    deleteBindedGoods(){
      let id = this.currentRelationLink.good_id;
      let index = this.binged_goods.findIndex((i)=>i.id==id);
      if(index>-1)
        this.binged_goods.splice(index,1);
      this.currentRelationLink.good_id=''
    },
    handleAutoChange(value){
      if(!value){
        this.merchant_country=''
        this.merchant_id=''
        
      }
    },
    handleAutoSelect(item){
      this.newArticle.merchant_tag=item.tag;
      this.merchant_url=item.website;
      this.merchant_id = item.id;
      this.merchant_country = item.country;
    },
    async querySearch(queryString, cb){
      let query = {
        keyword: queryString
      }
      let res = await api.searchBusiness(this,query)
      let arr = []
      res.body.result.forEach(item => {
        arr.push({value:item.name,id:item.id,tag:item.tag,country:item.country})
      })
      cb(arr)
    },
    async getConvert(original_id){
      this.loadingEdit=true;
      let data = {
        id:original_id
      }
      let res = await api.get(this, {
        path: 'spider.php',
        api: 'get_post_detail_for_joyorders',
        params: data
      })
      res = res.body
      if (res.status == 'ok') {
       this.newArticle = res.result;
       this.newArticle.post_monitoring_id = this.post_monitoring_id
       //this.getDoubao();
       if(this.newArticle.type && this.newArticle.type!='0'){
        this.relationMerchant = this.newArticle.merchant_info && this.newArticle.merchant_info.name?this.newArticle.merchant_info.name:'未知商家'
        this.merchant_id = this.newArticle.merchant_info && this.newArticle.merchant_info.id?this.newArticle.merchant_info.id:'';
       }
       if(this.newArticle.media_list.length)
        this.mediaType = this.newArticle.media_list[0].type=='video'?'video':'picture';
       if(this.newArticle.good_list && this.newArticle.good_list.length)
        this.generateGoodsDisplay();
       this.loadingEdit=false;
       this.step=1;
        //this.generateContent(this.detail.content);
      }
    },
    async getDetail(id){
      this.loadingEdit=true;
      let data = {
        post_id:id
      }
      let res = await api.get(this, {
        path: 'cm.php',
        api: 'get_post_detail',
        params: data
      })
      res = res.body
      if (res.status == 'ok') {
       this.newArticle = res.result;
       //this.getDoubao();
       if(this.newArticle.type && this.newArticle.type!='0'){
        this.relationMerchant = this.newArticle.merchant_info && this.newArticle.merchant_info.name?this.newArticle.merchant_info.name:'未知商家'
        this.merchant_id = this.newArticle.merchant_info && this.newArticle.merchant_info.id?this.newArticle.merchant_info.id:'';
       }
       this.mediaType = this.newArticle.media_list[0].type=='video'?'video':'picture';
       if(this.newArticle.good_list && this.newArticle.good_list.length)
        this.generateGoodsDisplay();
       this.loadingEdit=false;
       this.step=1;
        //this.generateContent(this.detail.content);
      }
    },
    generateGoods(){
      let arr =[];
      this.newArticle.relationGoodsDisplay.forEach((g)=>{
        let o = {}
        //o.sid = index;
        o.type = g.type;
        switch(g.type){
          case 'merchant_good':
            o.good_id = g.id || g.good_id;
            o.merchant_id =  this.merchant_id || g.merchant_id || g.default_merchant_id;
            arr.push(o);
            break;
          case 'url':
            o=JSON.parse(JSON.stringify(g));
            arr.push(o);
            break; 
        }
      });
      return arr;
    },
    generateGoodsDisplay(){
      this.newArticle.relationGoodsDisplay=[];
      this.newArticle.good_list.forEach((g,index)=>{
        switch(g.type){
          case 'merchant_good':
            g.cover_image = g.image_url;
            g.sid = index;
            this.newArticle.relationGoodsDisplay.push(g);
            break;
          case 'url':
            let o = {};
            o.type='url'
            o.url_content={};
            o.url_content.name=g.name;
            o.url_content.price=g.price;
            o.url_content.discounted_price=g.discounted_price;
            o.url_content.currency_symbol=g.currency_symbol;
            o.url_content.currency=g.currency;
            o.url=g.url;
            o.url_image_url=g.image_url;
            o.sid = index;
            this.newArticle.relationGoodsDisplay.push(o);
            break; 
        }
      })
    },
    test(){
      console.log('test',this.newArticle.type)
    },
    deleteImage(){
      this.currentRelationLink.url_image_url='';
      this.$forceUpdate();
    },
    handleImageLoad(event,index) {
      const img = event.target;
        const aspectRatio = img.naturalWidth / img.naturalHeight;
        this.upload_relation_image_width = 500 * aspectRatio;
    },
    editLink(item,index){
      this.currentRelationLink=JSON.parse(JSON.stringify(item));
      this.dialogFormVisible=true;
      this.relationType='link';
      this.editIndex = index;
    },
    confirm(){
      this.errormessage=''
      if(!this.currentRelationLink.url_content.name){
        this.errormessage='商品名称是必填项';
        return;
      }
      if(!this.currentRelationLink.url){
        this.errormessage='商品网址是必填项';
        return;
      }
      if(!this.currentRelationLink.url_image_url){
        this.errormessage='请上传图片';
        return;
      }
      if(!this.currentRelationLink.url_content.price){
        this.errormessage='商品价格是必填项';
        return;
      }
      this.dialogFormVisible=false;

      if(!this.newArticle.good_list){
        this.newArticle.good_list=[];
      }
      if(!this.newArticle.relationGoodsDisplay){
        this.newArticle.relationGoodsDisplay=[];
      }
      let o = JSON.parse(JSON.stringify(this.currentRelationLink));
      if(!o.url_content.discounted_price)
        o.url_content.discounted_price=o.url_content.price;
      o.url_content.price=parseFloat(o.url_content.price).toFixed(2);
      o.url_content.discounted_price=parseFloat(o.url_content.discounted_price).toFixed(2);

      if(this.editIndex>-1){
        o.sid = this.editIndex;
        this.newArticle.relationGoodsDisplay[this.editIndex]=o;
        this.newArticle.good_list[this.editIndex]=o;
        this.editIndex=-1;
      }
      else{
        o.sid = this.newArticle.relationGoodsDisplay.length;
        this.newArticle.relationGoodsDisplay.push(o);
        this.newArticle.good_list.push(o);
      }
      console.log('test',this.newArticle.good_list);
      this.currentRelationLink={
        type:'url',
        url_content:{
          currency:'USD',
          currency_symbol:'$'
        }
      }
    },
    handleLinkStepSelect(data){
      this.currentRelationLink.good_id=data.id;
      this.binged_goods.push(data);
      this.link_step=1;
    },
    handleSelect(data,isCollection){
      this.dialogFormVisible=false;
      if(!this.newArticle.good_list){
        this.newArticle.good_list=[];
      }
      if(!this.newArticle.relationGoodsDisplay){
        this.newArticle.relationGoodsDisplay=[];
      }
      let l = this.newArticle.relationGoodsDisplay.length
      if(isCollection=='1'){
        data.forEach((i,index)=>{
          i.sid = l+index;
          if(i.type=='merchant_good'){
            i.cover_image = i.cover_image.small;
            let o = {};
            o.type='merchant_good';
            o.good_id=i.id;
            o.merchant_id= this.merchant_id || i.default_merchant_id;
            o.url=i.url;
            
            this.newArticle.relationGoodsDisplay.push(i);
            this.newArticle.good_list.push(o);
          }
          else if(i.type == 'url'){
            let o = {};
            o.type='url'
            o.url_content={};
            o.url_content.name=i.name;
            o.url_content.price=i.price;
            o.url_content.discounted_price=i.discounted_price;
            o.url_content.currency_symbol=i.currency_symbol;
            o.url_content.currency=i.currency;
            o.url=i.url;
            o.url_image_url=i.cover_image.small;

            this.newArticle.relationGoodsDisplay.push(i);
            this.newArticle.good_list.push(o);
          }
        })
      }
      else{
        data.forEach((i,index)=>{
          i.sid = l+index;
          i.type='merchant_good';
          let o = {};
          o.type='merchant_good';
          o.good_id=i.id;
          o.merchant_id= this.merchant_id || i.default_merchant_id;
          o.url=i.url;
          if(!this.newArticle.good_list){
            this.newArticle.good_list=[];
          }
          if(!this.newArticle.relationGoodsDisplay){
            this.newArticle.relationGoodsDisplay=[];
          }
          this.newArticle.relationGoodsDisplay.push(i);
          this.newArticle.good_list.push(o);
          //console.log('test',this.newArticle.good_list,this.merchant_id)
        })
      }
    },
    addRelation(){
      this.dialogFormVisible=true;
    },
    handleClick(tab){
      this.mediaType=tab.name;
    },
    editSave(){
      if(this.mediaType=='video'){
        this.newArticle = JSON.parse(this.videosaveContent);
      }
      else{
        this.newArticle = JSON.parse(this.saveContent);
      }
      this.step=1;
    },
    clearSave(abondon){
      if(this.mediaType=='video'){
        this.$localStorage.remove('videoarticle');
        this.$localStorage.remove('videoInfo');
        this.videosaveContent='';
      }
      else{
        this.$localStorage.remove('article');
        this.saveContent='';
      }
      this.$localStorage.remove('article_merchant');
      this.$localStorage.remove('article_merchant_url');
      this.$localStorage.remove('article_merchant_id');
      if(abondon){
        this.newArticle={
            visibility:'0',
            location:{
              name:''
            }
        }
      }
    },
    generateAtUser(content){
      let users = [];
      const regex = /@([^<]+)(?=<\/a>)/g;
      //let content = this.$refs.myQuillEditor.quill.root.innerHTML
      let matches = content.match(regex);
      if(matches!=null && matches.length>0){
        let arr = matches.map((i)=>{
          return i
        });
        arr = [...new Set(arr)];
        arr.forEach((m)=>{
          let u = m.replace('@','');
          let o = this.atuserlist.find((i)=>{
              let name = i.name || i.username
              if(name == u)
                return true
              else
                return false
          })
          users.push(o.account_id);
        })
      }
      console.log('content',content,this.atuserlist,users);

      return users;
    },
    save(){
      let content = this.$refs.myQuillEditor.quill.root.innerHTML;
      let users = this.generateAtUser(content);
      if(this.mediaType=='video'){
        this.videosaveContent=JSON.stringify(this.newArticle)
        this.$localStorage.set('videoarticle',this.videosaveContent);
        this.$localStorage.set('videoInfo',JSON.stringify(this.videoInfo));
        if(users.length)
          this.$localStorage.set('article_atuser',JSON.stringify(users))
      }
      else{
        this.saveContent=JSON.stringify(this.newArticle)
        this.$localStorage.set('article',this.saveContent);
        if(users.length)
          this.$localStorage.set('article_atuser',JSON.stringify(users))
      }
      if(this.newArticle.type && this.newArticle.type!='0'){
        this.$localStorage.set('article_merchant',this.relationMerchant);
        this.$localStorage.set('article_merchant_url',this.merchant_url);
        this.$localStorage.set('article_merchant_id',this.merchant_id);
      }
      if(this.post_id && !this.post_monitoring_id){
        this.submitting=true;
        let params = JSON.parse(JSON.stringify(this.newArticle));
        params.good_list = this.generateGoods();
        delete params.relationGoodsDisplay;
        params.content = content;
        params.status = 0;
        api.updateArticle(this,params).then((res)=>{
          this.submitting=false;
          this.$message.success('保存成功');
          this.$router.push(
            {path:'/explore'}
          )
        })
      }
      else{
        this.step=0;
        this.$message.success('保存成功');
      }
    },
    clearMedia(){
      this.newArticle.media_list=0;
      this.restLimit=18;
      this.step=0;
    },
    handleReplace(index){
      this.mediaIndex = index;
    },
    del(index){
      this.newArticle.media_list.splice(index,1);
      this.$forceUpdate()
    },
    delRelation(index){
      this.newArticle.good_list.splice(index,1);
      this.newArticle.relationGoodsDisplay.splice(index,1);
      this.$forceUpdate()
    },
    handleFileChange(file) {
      this.fileQueue.push(file.raw);
    },
    handleEditorFile(file) {
      this.editorfileQueue.push(file.raw);
    },
    captureCurrentFrame(video) {
      const canvas = document.createElement('canvas')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      canvas.getContext('2d').drawImage(video, 0, 0)
      return canvas.toDataURL('image/jpeg')
    },
    async captureFrame(video, time, videoURL) {
      const frameTimes = [0, 0.5, 1] // 前三秒的三个时间点
    
      for (const time of frameTimes) {
        video.currentTime = time
        await new Promise(resolve => {
          video.requestVideoFrameCallback(() => {
            const frame = this.captureCurrentFrame(video)
            this.frames.push(frame);
            resolve()
          })
        })
      }
    },
    openInsertLink(){
      const quill = this.$refs.myQuillEditor.quill;
      quill.focus()
      setTimeout(()=>{
        const range = quill.getSelection()
        console.log('test',range);
        if (!range) {
          this.$message.error('请先选择要添加链接的文本!');
          return
        }
        
        if (range.length === 0) {
          this.$message.error('请先选择要添加链接的文本!');
          return
        }
        this.link_text = quill.getText(range.index, range.length)
        this.linkVisible=true;
      },100)
    },
    insertLink(){
      const quill = this.$refs.myQuillEditor.quill;
      quill.focus()
      setTimeout(()=>{
        /*const range = quill.getSelection()
        if (!range) {
          this.$message.error('请先选择要添加链接的文本!');
          return
        }
        
        if (range.length === 0) {
          this.$message.error('请先选择要添加链接的文本!');
          return
        }*/
        
        quill.format('link', this.rich_text_link)
        this.linkVisible=false;
      },100)
    },
    beforeVideoReplaceUpload(params) {
      //console.log('video',params);
      this.uploadingVideo=true;
      const allowedTypes = ['video/mp4', 'video/mov'];
      const isAllowed = allowedTypes.includes(params.type);
      const isLt2M = params.size / 1024 / 1024 < 20000;
      this.videoInfo.videoSize = (params.size/ 1024 / 1024).toFixed(2)+'MB';
      this.videoInfo.videoName = params.name;

      const video = this.$refs.videoPlayer
      const videoURL = URL.createObjectURL(params)
      
      video.src = videoURL

      video.onloadedmetadata = async () => {
        this.videoInfo.videoduration = (video.duration).toFixed(2)+'s';
        
        //const frameRate = 30 // 假设30fps，可根据实际情况调整
        
        // 计算要截取的时间点（前三帧）
        //const captureTimes = [0, 1/frameRate, 2/frameRate].map(t => Math.min(t, this.videoduration))
        
        //await this.captureFrame(video);
        //this.videoInfo.selectedCover=this.frames[0];
        //console.log('frames',this.frames);
      }
      if (!isAllowed) {
        this.$message.error('只能上传 mp4、mov格式的视频!');
        this.uploadingVideo=false;
      }
      if (!isLt2M) {
        this.$message.error('文件大小不能超过 20GB!');
        this.uploadingVideo=false;
      }  

      return isAllowed && isLt2M;
    },
    beforeReplaceUpload(params) {
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg','image/webp'];
      const isAllowed = allowedTypes.includes(params.type);
      const isLt2M = params.size / 1024 / 1024 < 32;

      if (!isAllowed) {
        this.$message.error('只能上传 png、jpg、jpeg、webp 格式的图片!');
      }
      if (!isLt2M) {
        this.$message.error('文件大小不能超过 32MB!');
      }
      if(isAllowed && isLt2M)
        this.replaceing = true;    
      return isAllowed && isLt2M;
    },
    beforeRelationUpload(params) {
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg','image/webp'];
      const isAllowed = allowedTypes.includes(params.type);
      const isLt2M = params.size / 1024 / 1024 < 32;

      if (!isAllowed) {
        this.$message.error('只能上传 png、jpg、jpeg、webp 格式的图片!');
      }
      if (!isLt2M) {
        this.$message.error('文件大小不能超过 32MB!');
      }  
      return isAllowed && isLt2M;
    },
    beforeEditorUpload(params) {
      if (this.isEditorUploading) return false;
      setTimeout(() => {
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg','image/webp'];

        let isAllowed = true;

        for(let i = 0;i<this.editorfileQueue.length;i++){
          isAllowed = allowedTypes.includes(this.editorfileQueue[i].type);
          if(!isAllowed){
            this.editorfileQueue=[];
            break;
          }
        }

        if (!isAllowed) {
          this.$message.error('只能上传 png、jpg、jpeg、webp 格式的图片!');
        }
        
        if (this.editorfileQueue.length > 0 && !this.isEditorUploading) {
          this.uploadEditorFiles();
        }
        }, 100); 

      return false;
    },

    beforeUpload(params) {
      if (this.isUploading) return false;

      setTimeout(() => {
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg','image/webp'];

        let isAllowed = true;
        let isLt2M = true;

        for(let i = 0;i<this.fileQueue.length;i++){
          isAllowed = allowedTypes.includes(this.fileQueue[i].type);
          isLt2M = this.fileQueue[i].size / 1024 / 1024 < 32;
          if(!isAllowed || !isLt2M){
            this.fileQueue=[];
            break;
          }
        }

        if (!isAllowed) {
          this.$message.error('只能上传 png、jpg、jpeg、webp 格式的图片!');
        }
        if (!isLt2M) {
          this.$message.error('文件大小不能超过 2MB!');
        }
        if (this.fileQueue.length > 0 && !this.isUploading) {
          this.uploadAllFiles();
        }
        }, 100); 

      return false;
    },
    uploadEditorFiles() {
      this.isInsertImage=true;
      const quill = this.$refs.myQuillEditor.quill;
      quill.focus()

      setTimeout(async ()=>{
        const range = quill.getSelection()
        const cursorPosition = range ? range.index : quill.getLength()
        
        this.showLoading(cursorPosition)
        if (this.editorfileQueue.length === 0) return;
        this.isEditorUploading = true;
        const formData = new FormData();
        this.editorfileQueue.forEach(file => {
          formData.append('base64_list[]', file);
        });
        
        let res = await api.post(this, {
          path: API_HOST+'/api/upload.php?type=base64',
          api: 'mul_upload_base64_picture',
          data:formData
        })
        res = res.body
        this.editorfileQueue=[]
        this.isEditorUploading=false;
        if (res.status !== 'ok') {
          this.$message.error('上传失败：'+res.result)
          this.removeLoading(cursorPosition)
          return;
        }
        res.result.forEach((u)=>{
          this.insertImage(cursorPosition, u)
        })
        this.isInsertImage=false;
      },100)
    },
    showLoading(position) {
      const quill = this.$refs.myQuillEditor.quill;
      quill.insertText(position, '⏳ 图片上传中...', { 
        color: '#999',
        background: '#f5f5f5'
      })
      this.loadingPosition = position
      this.loadingLength = '⏳ 图片上传中...'.length
    },
    
    removeLoading(position) {
      const quill = this.$refs.myQuillEditor.quill;
      // 删除加载提示
      if (this.loadingPosition !== undefined) {
        quill.deleteText(this.loadingPosition, this.loadingLength)
        this.loadingPosition = undefined
      }
    },
    
    insertImage(position, url) {
      const quill = this.$refs.myQuillEditor.quill;
      // 删除加载提示（如果有）
      this.removeLoading(position)
      
      quill.insertText(position, '\n');

      // 插入图片
      quill.insertEmbed(position+1, 'image', url)
      
      // 将光标移到图片后面
      quill.insertText(position+2, '\n');
      quill.setSelection(position + 3)
    },
    async uploadAllFiles() {
      if (this.fileQueue.length === 0) return;
      this.isUploading = true;
      const formData = new FormData();
      this.fileQueue.forEach(file => {
        formData.append('base64_list[]', file);
      });
      
      let res = await api.post(this, {
        path: API_HOST+'/api/upload.php?type=base64',
        api: 'mul_upload_base64_picture',
        data:formData
      })
      res = res.body
      this.fileQueue=[]
      this.isUploading=false;
      if (res.status !== 'ok') {
        this.$message.error('上传失败：'+res.result)
        return;
      }
      if(!this.newArticle.media_list)
        this.newArticle.media_list=[]
      res.result.forEach(r=>{
        this.newArticle.media_list.push({url:r,type:'image'})
      })
      this.restLimit=this.restLimit-this.newArticle.media_list.length;
      this.step=1;
      this.clearSave();
    },
    chooseUser(user){
      let item = user.name || user.username
      let word = ''
      let keywordlength = this.keyword.length;
      if(this.keyword!=''){
        word = this.keyword.replace('@','').replace('\n','');
        item = item.replace(word,'');
      }
      this.userdialogshow=false;
      const quill = this.$refs.myQuillEditor.quill;
      quill.focus();
      setTimeout(()=>{
        let cursorPosition = quill.getSelection().index;
        //quill.deleteText(cursorPosition-this.keyword.length+1,this.keyword.length);
        //quill.insertText(cursorPosition, item+" ");
        quill.updateContents([
          // 1. 保留光标前的文本
          { retain: cursorPosition-this.keyword.length+1 },
          // 2. 删除关键词（长度为 keywordLength）
          { delete: this.keyword.length },
          // 3. 插入选中的用户名
          { insert: item+" " }
        ]);
        quill.formatText(cursorPosition-keywordlength, item.length+1, {
          color: '#104da1'
        });
        //quill.formatText(cursorPosition, item.length, 'link','#');
        //quill.format('class', 'user-class', cursorPosition-this.keyword.length, this.keyword.length+item.length)
        quill.formatText(cursorPosition-keywordlength, item.length+1, 'link','#quilluser');
        this.keyword=''
        //if(!this.atuserlist.find(i=>i.account_id==user.account_id))
        this.atuserlist.push(user)
      },500)
    },
    chooseTag(item){
      let word = ''
      let keywordlength = this.keyword.length;
      if(this.keyword!=''){
        word = this.keyword.replace('#','').replace('\n','');
        item = item.replace(word,'');
      }
      this.huatidialogshow=false;
      const quill = this.$refs.myQuillEditor.quill;
      quill.focus();
      setTimeout(()=>{
        const cursorPosition = quill.getSelection().index;
        quill.insertText(cursorPosition, item+" ");
        quill.formatText(cursorPosition-keywordlength, word.length+item.length+1, {
          color: '#104da1'
        });
        //quill.formatText(cursorPosition, item.length, 'link','#');
        //quill.format('class', 'my-custom-class', cursorPosition-this.keyword.length, this.keyword.length+item.length)
        quill.formatText(cursorPosition-keywordlength, word.length+item.length+1, 'link','#quilltag');
        this.keyword=''
      },500)
    },
    chooseTopTag(item){
      item='#'+item;
      const quill = this.$refs.myQuillEditor.quill;
      quill.focus();
      setTimeout(()=>{
        const cursorPosition = quill.getSelection().index;
        quill.insertText(cursorPosition, item+" ");
        quill.formatText(cursorPosition, item.length, {
          color: '#104da1'
        });
        quill.formatText(cursorPosition, item.length, 'link','#quilltag');
      },500)
    },
    async searchUser(keyword){
      let w = keyword.replace('@','').replace('\n','');
      this.userdialogshow=true;
      this.searchingTag=true;
      let res = await api.post(this, {
        path: 'buyer.php',
        api: 'search_account_list',
        data: w?{keyword:w}:{}
      })
      this.searchingTag=false;
      res = res.body
      if (res.status == 'ok') {
        this.users = res.result;
      }
    },
    async searchTags(keyword){
      let w = keyword.replace('#','').replace('\n','');
      this.huatidialogshow=true;
      this.searchingTag=true;
      let res = await api.get(this, {
        path: 'cm.php',
        api: 'search_tag_list',
        params: w?{keyword:w}:{}
      })
      this.searchingTag=false;
      res = res.body
      if (res.status == 'ok') {
        this.tags = res.result;
      }
    },
    async getTopTags(){   
      let res = await api.post(this, {
        path: 'cm.php',
        api: 'search_tag_list',
        data: {}
      })
      res = res.body
      if (res.status == 'ok') {
        this.topTags=res.result.filter((i,index)=>index<3)
      }
    },
    triggerUsers(){
      const quill = this.$refs.myQuillEditor.quill;
      quill.focus();
      setTimeout(()=>{
        const cursorPosition = quill.getSelection().index;
        quill.insertText(cursorPosition, "@");
        this.searchUser('');
      },500)
    },
    triggerTags(){
      const quill = this.$refs.myQuillEditor.quill;
      quill.focus();
      setTimeout(()=>{
        const cursorPosition = quill.getSelection().index;
        quill.insertText(cursorPosition, "#");
        this.searchTags('');
      },500)
    },
    async getTags(){
      let res = await api.post(this, {
        path: 'cm.php',
        api: 'get_recommended_tag_list_when_add_post',
        data: data
      })
      res = res.body
      if (res.status == 'ok') {
        this.tags = res.result;
      }
    },
    async getLocation(){
      let res = await api.get(this, {
        path: 'cm.php',
        api: 'get_location',
      })
      res = res.body
      if (res.status == 'ok') {
        this.newArticle.location.name = res.result.ip_province;
      }
    },
    handlerQuill(delta){
      let quill = delta.quill;

      const range = quill.getSelection();
      const bounds = quill.getBounds(range.index);
      const editorRect = quill.container.getBoundingClientRect();
      
      this.huatileft=Math.round(editorRect.left + bounds.left)+'px'
      this.huatitop=Math.round(editorRect.top + bounds.top)+15+'px'
      if (this.isInsertImage) {
          return
      }

      let length = quill.getLength();
      if(length>1){
        let content = quill.getText(0,range.index);
        let s_arr = content.split('\n');
        let s = s_arr[s_arr.length-1];
        let s1_arr = s.split(' ');
        let s1 = s1_arr[s1_arr.length-1];
        let last = '';
        if(s1==''){
          this.keyword=''
          this.huatidialogshow=false;
          this.userdialogshow=false;
        }
        else{
          if(s1.length==1)
            last = s1;
          else
            last = s1.substring(s1.length-2);
          if(/\s/.test(last)){
            this.keyword=''
            this.huatidialogshow=false;
            this.userdialogshow=false;
          }
          else{              
            let lastIndex = s1.lastIndexOf('#');
            let lastUserIndex = s1.lastIndexOf('@');
            if(lastIndex>-1){
              this.keyword = s1.substring(lastIndex,s1.length);
              this.searchTags(this.keyword);
            }
            else if(lastUserIndex>-1){
              this.keyword = s1.substring(lastUserIndex,s1.length);
              this.searchUser(this.keyword);
            }
          }
        }
      }
      else{
        this.huatidialogshow=false;
        this.userdialogshow=false;
      }
    },
    handleUploadSuccess: function(response, file, fileList) {
      this.replaceing=false;
      this.newArticle.media_list[this.mediaIndex].url=response.result;
      this.$forceUpdate()
    },
    handleRelationSuccess: function(response, file, fileList) {
      this.currentRelationLink.url_image_url=response.result;
      this.$forceUpdate()
    },
    handleVideoUploadSuccess: async function(response, file, fileList) {
      this.newArticle.cover_image_url=response.result.picture_url;
      this.uploadingVideo=false;
      let o = { url:response.result.video_url,type:'video'};
      this.newArticle.media_list=[o];
      this.step=1;
    },
    submit(){
      if(this.newArticle.media_list.length==0){
        this.$message.error("请上传图片");
        return
      }
      if(!this.newArticle.content){
        this.$message.error("请填写内容");
        return
      }
      if(this.newArticle.type && this.newArticle.type!='0'){
        if(this.relationMerchant=='未知商家')
          this.newArticle.merchant_tag='';
        if(!this.newArticle.merchant_tag){
          this.$message.error("商家帖子需要关联商家");
          return
        }       
      }
      //console.log('content',this.$refs.myQuillEditor.quill.getText());
      //return;
      const submitFinal = ()=>{
        this.submitting=true;
        let params = JSON.parse(JSON.stringify(this.newArticle));
        //params.content = this.$refs.myQuillEditor.quill.getText();
        params.content = this.$refs.myQuillEditor.quill.root.innerHTML
        params.account_id_list = this.generateAtUser(params.content);
        if(params.post_id && !this.post_monitoring_id){
          params.good_list = this.generateGoods();
          delete params.relationGoodsDisplay;
          params.status = 1
          api.updateArticle(this,params).then((res)=>{
            this.submitting=false;
            if(res.body.status=='error'){
              ;
            }
            else{
              this.$message.success('发布成功');
              this.$router.push(
                {path:'/explore'}
              )
            }
          })
        }
        else{
          if(this.newArticle.post_monitoring_id){
            params.good_list = this.generateGoods();
          }
          delete params.relationGoodsDisplay;
          api.addArticle(this,params).then((res)=>{
            this.submitting=false;
            if(res.body.status=='error'){
              ;
            }
            else{
              this.$message.success('发布成功');
              this.$router.push(
                {path:'/explore'}
              )
            }
        })
        }
      }
      const checkDomainValid = ()=>{
        let arr = this.newArticle.good_list;
        let result = false;
        this.arr_domainInvalid = [];
        for(var i = 0;i<arr.length;i++){
          if(arr[i].url && arr[i].url.indexOf(this.merchant_url)==-1){
            result = true;
            this.arr_domainInvalid.push(i+1);
          }
        }
        return result;
      }
      if(this.newArticle.good_list && this.newArticle.good_list.length && checkDomainValid()){
        let title = '您关联的商品中第'+this.arr_domainInvalid.join(',')+'个商品的官网地址与当前商家不一致, 确认提交吗?'
        this.$confirm(title, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            cancelButtonClass: 'customCancelButton',
            confirmButtonClass: 'customConfirmButton',
            center: true
        }).then(() => {
            submitFinal()
        }).catch(() => {
        });
      }
      else{
        submitFinal();
      }
      
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .product_image_wrapper{
    width:48px;
    height:48px;
    position:relative;
  }
  .product_image{
    width:48px;
    height:48px;
    object-fit: contain;
    position: relative;
  }
  .product_image.nostock{
    opacity: 0.5;
  }
  .product_image_wrapper.nostock:before {
		position: absolute;
		content: "";
		width: 100%;
		left: 0;
		top: 50%;
		right: 0;
		border-top: 2px solid #ccc;
		transform: rotate(-45deg);
		z-index: 1;    
	}
  .merchant-nostock{
    position: absolute;
		top: 2px;
		right: -14px;
		font-size: 9px;
		background: #ccc;
		color: white;
		width: 50px;
		height: 16px;
		line-height: 16px;
		text-align: center;
		transform: rotate(45deg);
  }
  .exception-label{
    font-size: 10px;
    text-align: center;
    background-color: #f3f3f9;
    border-color: #dee1eb;
    color: #686b73;
    padding: 4px 3px;
    cursor: pointer;
  }
  .copyTxtSuccess{
    background-color: #f4f4f5 !important;
    color: #909399 !important;
    border-color: #f4f4f5 !important;
  }
  .emptyContent{
    width:100%;
    text-align: center;
    padding-top:10%;
    color:rgba(51,51,51,0.6)
  }
  .flag {
    width: 20px;
    height: 14px;
    object-fit: contain;
    position: relative;
    top:2px;
  }
  .video-info{
    background-color: rgba(0,0,0,0.03);
    display: flex;
    padding:17px 30px 17px 30px;
    align-items: center;
    justify-content: space-between;
  }
  .error-messages {
    background-color: #fff1f1;
    padding: 10px;
    text-align: center;
    color: #ff4650;
    line-height: 17px;
    margin-bottom: 10px;
    border-radius: 5px;
    li {
      font-size: 12px;
    }
  }
  .goods_info_row{
    display: flex;
    margin-bottom:10px;
    justify-content: space-between;
  }
  .order-list{
    margin-bottom: 0 !important;
  }
  .tip{
    flex:1;
    text-align: center;
    padding:0 20px;
    border-right: 1px solid #f4f4f4;
  }
  .savewarning{
    border-radius: 4px;
    height: 40px;
    line-height: 40px;
    margin-bottom: 12px;
    font-size: 14px;
    background:#f7f7f7;
  }
  .content-wrapper{
    width:70%;
    overflow: auto;
    padding:28px 30px 0;
  }
  .content-wrapper::-webkit-scrollbar{
    display: none;
  }
  .top-tag{
    background:rgba(0,0,0,0.03);
    padding:12px 16px;
    margin-left:12px;
    width:24%;
  }
  .top-tag-button{
    margin-top: 4px;
    font-size: 12px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.53);
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .article_card{
    display: flex;
    margin-bottom:10px;
    padding-bottom:10px;
    border-bottom:1px solid #ccc;
  }
.drag-upload{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width:100%;
  height:100%;
  border:2px dashed #ccc;
  border-radius: 4px;
  background:rgb(247,247,247);
  position: relative;
}
.add-picture{
  width:96px;
  height:96px;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  border:1px dashed #ccc;
  border-radius: 4px;
  background:rgb(247,247,247);
  margin-bottom:10px;
}
.add-picture-img{
  width:96px;
  height:96px;
  position:relative;
  margin-left:12px;
  margin-bottom:10px;
  border:1px solid #ccc;
  border-radius: 4px;
  img.replaceing{
    opacity: 0.2;
  }
}
.editor_tag{
  height:28px;
  display: inline-block;
  line-height: 20px;
  padding: 4px 10px;
  background:rgb(247,247,247);
  border-radius: 4px;
  color:#333;
  cursor:pointer;
}
.editor_tag.small{
  height:14px;
  display: inline;
  padding: 2px 5px;
  border-radius: 4px;
  font-size: 11px;
  color: #333;
  position: relative;
  top:-1.5px;
}
.huatidialog{
  position:fixed;
  z-index:9999;
  border:1px solid #ccc;
  box-shadow: #ccc;
  width:390px;
  height: 190px;
  background: white;
  overflow: auto;
}
.huatidialog::-webkit-scrollbar{
  display: none;;
}
.operations1 {
    display: none;
    position: absolute;
    bottom: 0;
    z-index: 100;  
    width: 100%;
    height: 28px;
    line-height: 28px;
    background: rgba(0,0,0,0.3);
    color:white;
}
.operations {
    display: none;
    position: absolute;
    right: 0px;
    top: 0px;
    z-index: 100;  
    width: 20px;
    height: 20px;   
    .del {
      background:rgba(0,0,0,0.6);
      cursor: pointer;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
}
.realation_image_wrapper{
  height:500px;
  position: relative;
}
.add-picture-img:hover,.relation_product:hover,.realation_image_wrapper:hover,.relation_product_ex:hover {
  .on {
    display: block;
  }
}
.huati-item{
  height:32px;
  cursor: pointer;
  line-height: 32px;
  margin:2px 5px;
}
.huati-item:hover{
  background:rgba(0,0,0,0.08);
}
.relation_product_wrapper{
  width:49%;
  margin:10px 0 20px;
  .on{
    display: none;
  }
}
.relation_product_wrapper:hover{
  .on{
    display:block;
  }
}
.relation_product_ex{
  width:100%;
  display: flex;
  align-items: center;
  position: relative;
}
.relation_product{
  width:49%;
  display: flex;
  align-items: center;
  position: relative;
  margin:10px 0 20px;
  /*cursor: pointer;*/
}
.relation_product_info{
  flex:1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 48px;
  margin-left:2px;
}
.product-price{
  &.discounted{
    color:#ff4650;
  }
}
.emoji-item {
  cursor: pointer;
  font-size: 24px;
  padding: 4px 0px 6px 0px;
  margin:5px 0;
  border-radius: 4px;
  width:40px;
  transition: background 0.2s;
  text-align: center;
}

.emoji-item:hover {
  background: #000;
}
</style>



// WEBPACK FOOTER //
// src/pages/articles/Publish.vue